import React from 'react';

const AllNotificationsIcon = ({ color = '#9D9D9D', width = '16', height = '16', ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.95 13.9833L9.06667 12.1L10 11.1667L10.95 12.1167L13.0667 10L14 10.9333L10.95 13.9833ZM2 14V12.6667H8V14H2ZM2 11.3333V10H8V11.3333H2ZM2 8.66667V7.33333H14V8.66667H2ZM2 6V4.66667H14V6H2ZM2 3.33333V2H14V3.33333H2Z"
                fill={color}
            />
        </svg>
    );
};

export default AllNotificationsIcon;
